import { Invoice as InvoiceFromApi } from '@sdk/account/types/apiTypes';

import { Invoice } from './currentBillingPricing.types';

export const mapInvoiceFromAPIToUI = ({
  prorationAmount,
  subtotal,
  tax,
  total,
  discount,
  yearlyDiscount,
}: InvoiceFromApi): Invoice => ({
  prorationAmount,
  subtotal,
  tax,
  total,
  discount,
  yearlyDiscount: Number(yearlyDiscount) || 0,
});
